<template>
  <div id="app" class="antialiased">
    <Toast />
    <ValidationToast />
    <DynamicDialog />
    <component :is="$route.meta.layout || 'div'">
      <router-view></router-view>
    </component>
  </div>
</template>
<script setup>
import { inject, onBeforeMount } from 'vue'
import {useToast} from 'primevue/usetoast';
import {onMounted, onUnmounted, ref, watch} from 'vue';
import {useMessageStore} from "./stores/message.js";
import {useUserStore} from "./stores/user.js";
import { usePermissionsStore } from '@/stores/permissions'


import ValidationToast from './components/common/ValidationToast.vue';
import DynamicDialog from 'primevue/dynamicdialog';

import { useAppInit } from '@/composables/useAppInit.js';

const messageStore = useMessageStore();
const toast = useToast();
const userStore = useUserStore();

const i18n = inject('i18n')

watch(
    () => messageStore.message,
    (newMessage) => {
      if (newMessage) {
        toast.add({
          severity: messageStore.type,
          summary: messageStore.type.charAt(0).toUpperCase() + messageStore.type.slice(1),
          detail: newMessage,
          life: 3000,
        });
        messageStore.clearMessage();
      }
    }
);

onBeforeMount(async () => {
  const { initialize } =  useAppInit();
  await initialize();
});

onMounted(async () => {

  // load user locale 
  i18n.global.locale.value = userStore.getUserLocale || 'en-CA';
});

</script>
<style>
.preserve-newlines {
  white-space: pre-wrap;
}
</style>